var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('window',{attrs:{"title":"Float label <a href='https://github.com/bkzl/vue-float-label' target='_blank'>(more info)"}},[_c('float-label',[_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"Label"}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }